import { CLASSIFIED_EVENTS, EVENT_TITLES } from './event-titles';
import { LANES } from './lanes';

export interface PubRef {
  id: string;
  short: string;
  title: string;
}

export const PUBS: PubRef[] = [
  {
    id: 'pub:mcrp-2-10a-6',
    short: 'MCRP 2-10A.6',
    title: 'MCRP 2-10A.6 Ground Reconnaissance Operations',
  },
  {
    id: 'pub:mctp-3-01a',
    short: 'MCTP 3-01A',
    title: 'MCTP 3-01A Scouting and Patrolling (Jul 2020)',
  },
  {
    id: 'pub:navmc-3500-55d',
    short: 'NAVMC 3500.55D',
    title: 'NAVMC 3500.55D Reconnaissance T&R Manual',
  },
];

export const LANE_SHORT: Record<string, string> = {
  'cas-cff': 'CAS/CFF',
  'planning-mdrs': 'Planning',
  tak: 'TAK',
  demolitions: 'Demo',
  linkup: 'Linkup',
  'drop-zone': 'Drop zone',
  'hide-site': 'Hide site',
  sniper: 'Sniper',
  ambush: 'Ambush',
  raid: 'Raid',
  evasion: 'Evasion',
  'recon-patrol': 'Patrol',
};

export interface EventRef {
  id: string;
  code: string;
  title: string;
  classified: boolean;
  laneIds: string[];
}

export interface EventPrompt {
  laneId: string;
  lane: string;
  category: string;
  prompt: string;
  lookFor: string[];
}

let events: EventRef[] | null = null;

export function eventRefs(): EventRef[] {
  if (events) return events;
  const by = new Map<string, EventRef>();
  for (const lane of LANES) {
    for (const cat of lane.categories) {
      for (const code of cat.tasks) {
        const id = `event:${code}`;
        let row = by.get(id);
        if (!row) {
          const classified = CLASSIFIED_EVENTS.has(code);
          row = {
            id,
            code,
            title: classified ? 'Classified event' : EVENT_TITLES[code] || code,
            classified,
            laneIds: [],
          };
          by.set(id, row);
        }
        if (!row.laneIds.includes(lane.id)) row.laneIds.push(lane.id);
      }
    }
  }
  events = [...by.values()].sort((a, b) => a.code.localeCompare(b.code));
  return events;
}

export function promptsFor(code: string): EventPrompt[] {
  const out: EventPrompt[] = [];
  for (const lane of LANES) {
    for (const cat of lane.categories) {
      if (!cat.tasks.includes(code)) continue;
      out.push({
        laneId: lane.id,
        lane: lane.title,
        category: cat.title,
        prompt: cat.prompt,
        lookFor: cat.lookFor,
      });
    }
  }
  return out;
}

export function laneShort(id: string): string {
  return LANE_SHORT[id] || id;
}

export function isLibraryId(id: string): boolean {
  if (PUBS.some((pub) => pub.id === id)) return true;
  return id.startsWith('event:') && eventRefs().some((event) => event.id === id);
}

export function libraryLabel(id: string): string {
  const pub = PUBS.find((item) => item.id === id);
  if (pub) return pub.title;
  const event = eventRefs().find((item) => item.id === id);
  if (!event) return id;
  if (event.classified) return `${event.code} (classified)`;
  return `${event.code} — ${event.title}`;
}
